import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SelectCustom } from '../../../../common/selectCustom'
import { COMPARE_TYPE_DATA } from './constant'
import { changeCompareVal, selectCompareVal } from './store/slice'

const CompareSelect = () => {
  const dispatch = useDispatch()
  const compareVal = useSelector(selectCompareVal)

  const chooseItem = (item) => {
    dispatch(changeCompareVal(item.value))
  }
  return (
    <div
      className="dFlex gap1 alignItemsCenter pb1 mb1"
      style={{ borderBottom: '1px dashed #D5D5D5' }}
    >
      <Translate value="companyAnalysis.industryAnalysis.COMPARE_BETWEEN" />
      <SelectCustom
        isI18n
        style={{ marginLeft: 8 }}
        activeItem={COMPARE_TYPE_DATA.find((item) => item.value === compareVal)}
        data={COMPARE_TYPE_DATA}
        chooseItem={chooseItem}
      />
    </div>
  )
}

export default CompareSelect
